export const actionDefinitions = [
    {
        "key": "wait",
        "name": "wait",
        "time": "string",
        "type": "WAIT_ACTION",
        "label": "Wait",
        "status": true,
        "isFinal": false,
        "actionType": "wait",
        "breakpoint": false,
        "instruction": "string",
        "allowNesting": false,
        "instructionIndex": null,
        "totalManualSteps": 0,
        "description": "Delays the execution for a specified amount of time.",
        "supervitySchema": {
            "input": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "object",
                "properties": {
                    "time": {
                        "type": "string",
                        "description": "The amount of time to wait, specified as a string. Should be parsed appropriately to extract the time value."
                    }
                },
                "required": ["time"]
            },
            "output": {}
        }
    },
    {
        "key": "read",
        "type": "READ",
        "label": "read",
        "status": true,
        "isFinal": false,
        "subType": "string",
        "breakpoint": false,
        "readValue": false,
        "actionType": "read",
        "numberOnly": false,
        "configuring": false,
        "allowNesting": false,
        "readToVariable": "string",
        "readFromElement": "string",
        "instructionIndex": null,
        "totalManualSteps": 0,
        "description": "Action to read data from the specified element into a given variable",
        "supervitySchema": {
            "input": {
                "$schema": "http://json-schema.org/draft-04/schema#",
                "type": "object",
                "properties": {
                    "readValue": {
                        "type": "boolean",
                        "description": "Indicates if the value of the element to be read."
                    },
                    "numberOnly": {
                        "type": "boolean",
                        "description": "Indicates if only number to be extracted from the value."
                    },
                    "readToVariable": {
                        "type": "string",
                        "description": "Variable into which the element to be read."
                    },
                    "readFromElement": {
                        "type": "string",
                        "description": "Element from which the value to be read."
                    }
                },
                "required": ["readToVariable", "readFromElement"]
            },
            "output": {
                "$schema": "http://json-schema.org/draft-04/schema#",
                "type": "string"
            }
        }
    },
    {
        "key": "readtable",
        "type": "READ_TABLE",
        "label": "Read Table",
        "status": true,
        "xpath": "string",
        "colName": "string",
        "actionType": "READ_TABLE",
        "breakpoint": false,
        "configuring": true,
        "iframe_name": "string",
        "subActions": [],
        "allowNesting": false,
        "variableName": "string",
        "description": "Reads data from a table",
        "supervitySchema": {
            "input": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "object",
                "properties": {
                    "xpath": {
                        "description": "The XPath of the HTML table",
                        "type": "string"
                    },
                    "colName": {
                        "description": "The column name from the HTML table",
                        "type": "string"
                    },
                    "iframe_name": {
                        "description": "iFrame name if the HTML table present inside an iFRame",
                        "type": "string"
                    },
                    "variableName": {
                        "description": "The name of the variable associated with the object.",
                        "type": "string"
                    }
                },
                "required": ["xpath", "variableName"]
            },
            "output": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "array",
                "items": {
                    "description": "An array containing sring values from the specified column",
                    "type": "array",
                    "items": [
                        {
                            "description": "The first string value from the column",
                            "type": "string"
                        }
                    ]
                }
            }
        }
    },
    {
        "key": "screenshot",
        "type": "SCREENSHOT",
        "label": "Screenshot",
        "status": true,
        "filePath": "string",
        "actionType": "string",
        "breakpoint": false,
        "configuring": true,
        "allowNesting": false,
        "description": "Captures a screenshot",
        "supervitySchema": {
            "input": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "object",
                "properties": {
                    "filePath": {
                        "type": "string",
                        "description": "The file path where the screenshot to be saved."
                    }
                },
                "required": ["filePath"]
            },
            "output": {}
        }
    },
    {
        "cc": "string",
        "to": "string",
        "api": "string",
        "bcc": "string",
        "body": "string",
        "subject": "string",
        "isFinal": false,
        "key": "sendMail",
        "type": "SEND_OUTLOOK_MAIL",
        "label": "Send an email on Outlook",
        "actionType": "SEND_OUTLOOK_MAIL",
        "subActions": [],
        "attachments": "string",
        "configuring": false,
        "instructionIndex": null,
        "totalManualSteps": 0,
        "description": "Action to send an email using Outlook automation",
        "supervitySchema": {
            "input": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "object",
                "properties": {
                    "cc": {
                        "description": "The 'cc' (carbon copy) email address(es).",
                        "type": "string"
                    },
                    "to": {
                        "description": "The 'to' (recipient) email address(es).",
                        "type": "string"
                    },
                    "bcc": {
                        "description": "The 'bcc' (blind carbon copy) email address(es).",
                        "type": "string"
                    },
                    "body": {
                        "description": "The body content of the email.",
                        "type": "string"
                    },
                    "subject": {
                        "description": "The subject of the email.",
                        "type": "string"
                    },
                    "attachments": {
                        "description": "File attachments included in the email.",
                        "type": "string"
                    }
                },
                "required": ["to", "body", "subject"]
            },
            "output": {}
        }
    },
    {
        "key": "getMail",
        "type": "OUTLOOK_GET_MAIL",
        "label": "Get OutlookMail",
        "status": true,
        "top": "string",
        "custom": "string",
        "folder": "string",
        "mailId": "string",
        "moveTo": "string",
        "sender": "string",
        "unRead": "string",
        "isFinal": false,
        "actionType": "OUTLOOK_GET_MAIL",
        "breakpoint": false,
        "attachments": "string",
        "configuring": false,
        "allowNesting": true,
        "variableName": "string",
        "instructionIndex": null,
        "totalManualSteps": 0,
        "description": "Retrieve mail from Outlook",
        "supervitySchema": {
            "input": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "object",
                "properties": {
                    "top": {
                        "type": "string",
                        "description": "number of top emails to be read."
                    },
                    "read": {
                        "type": "boolean",
                        "description": "Whether the mail has to be marked as read or not after reading"
                    },
                    "moveTo": {
                        "type": "string",
                        "description": "Folder to which mail to be moved after reading"
                    },
                    "unRead": {
                        "type": "boolean",
                        "description": "Whether to fetch unread emails only or not"
                    },
                    "variableName": {
                        "type": "string",
                        "description": "Name of the variable into which mails to be loaded"
                    },
                    "folder": {
                        "type": "string",
                        "enum": ["Inbox", "Sent Items", "custom", "Deleted Items"],
                        "description": "Outlook Folder from which mail to be read"
                    }
                },
                "required": ["top", "folder", "variableName"],
                "if": {
                    "properties": {
                        "folder": {
                            "const": "custom"
                        }
                    }
                },
                "then": {
                    "properties": {
                        "custom": {
                            "type": "string",
                            "description": "The name of the custom folder from which mail to be read"
                        }
                    },
                    "required": ["custom"]
                },
                "else": {
                    "properties": {}
                }
            },
            "output": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "array",
                "items": [
                    {
                        "type": "object",
                        "properties": {
                            "Subject": {
                                "type": "string",
                                "description": "The subject of the email."
                            },
                            "Body": {
                                "type": "string",
                                "description": "The body content of the email."
                            },
                            "From": {
                                "type": "string",
                                "description": "The sender's email address."
                            },
                            "Received": {
                                "type": "string",
                                "description": "The timestamp when the email was received."
                            },
                            "ConversationID": {
                                "type": "string",
                                "description": "A unique identifier for the email conversation."
                            },
                            "EntryID": {
                                "type": "string",
                                "description": "A unique identifier for the email entry."
                            },
                            "DestinationEntryID": {
                                "type": "string",
                                "description": "A unique identifier for the destination email entry."
                            },
                            "AttachmentFileNames": {
                                "type": "array",
                                "items": {
                                    "type": "string",
                                    "description": "The names of attachments included in the email."
                                },
                                "description": "List of attachment file names."
                            },
                            "AttachmentsCount": {
                                "type": "integer",
                                "description": "The count of attachments included in the email."
                            }
                        },
                        "required": [
                            "Subject",
                            "Body",
                            "From",
                            "Received",
                            "ConversationID",
                            "EntryID",
                            "DestinationEntryID",
                            "AttachmentFileNames",
                            "AttachmentsCount"
                        ]
                    }
                ]
            }
        }
    },
    {
        "key": "sendOutlookMail",
        "type": "SAVE_ATTACHMENT",
        "label": "Save Attachment",
        "status": true,
        "isFinal": false,
        "filePath": "string",
        "mailType": "outlook",
        "breakpoint": false,
        "mailObject": "string",
        "subActions": [],
        "configuring": true,
        "allowNesting": true,
        "description": "Saves attachment from Outlook mail",
        "supervitySchema": {
            "input": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "object",
                "properties": {
                    "filePath": {
                        "description": "The Folder Path to Save Attachment",
                        "type": "string"
                    },
                    "mailObject": {
                        "description": "The mail object from which attachments to be downloaded",
                        "type": "string"
                    }
                },
                "required": ["filePath", "mailObject"]
            },
            "output": {}
        }
    },
    {
        "key": "catch",
        "type": "TRY_CATCH",
        "label": "Catch",
        "status": "string",
        "isFinal": false,
        "breakpoint": false,
        "subActions": [],
        "dependentActions": ["string"],
        "description": "Handles errors and exceptions gracefully within the automation flow.",
        "supervitySchema": {
            "input": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "object",
                "properties": {},
                "required": []
            },
            "output": {}
        }
    },
    {
        "key": "deletecolumn",
        "type": "DELETE_COLUMN",
        "groupType": "excel",
        "label": "Delete Column",
        "status": true,
        "colNum": "string",
        "sheetName": "string",
        "breakpoint": false,
        "allowNesting": false,
        "description": "Action to delete a specific column in a excel sheet",
        "supervitySchema": {
            "input": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "object",
                "properties": {
                    "path": {
                        "type": "string",
                        "description": "The path of the excel file."
                    },
                    "colNum": {
                        "type": "string",
                        "description": "The column number to be deleted"
                    },
                    "sheetName": {
                        "type": "string",
                        "description": "The name of the sheet in the excel file"
                    }
                },
                "required": ["path", "colNum", "sheetName"]
            },
            "output": {}
        }
    },
    {
        "key": "getrow",
        "type": "GET_ROW",
        "groupType": "excel",
        "label": "Get Row",
        "status": true,
        "rowNumber": "string",
        "sheetName": "string",
        "breakpoint": false,
        "storeCache": false,
        "allowNesting": false,
        "variableName": "string",
        "description": "Action to retrieve a specific row from a excel spreadsheet",
        "supervitySchema": {
            "input": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "object",
                "properties": {
                    "path": {
                        "type": "string",
                        "description": "The path of the excel file"
                    },
                    "rowNumber": {
                        "type": "string",
                        "description": "The row number to be fetched"
                    },
                    "sheetName": {
                        "type": "string",
                        "description": "The name of the sheet "
                    },
                    "variableName": {
                        "type": "string",
                        "description": "The variable name to capture the row data"
                    }
                },
                "required": ["path", "rowNumber", "sheetName", "variableName"]
            },
            "output": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "array",
                "items": [
                    {
                        "type": "string",
                        "description": "first item from the row"
                    }
                ]
            }
        }
    },
    {
        "key": "getrange",
        "type": "GET_RANGE",
        "groupType": "excel",
        "label": "Reads range of cells from a sheet in excel file",
        "status": true,
        "values": false,
        "sheetName": "string",
        "breakpoint": false,
        "storeCache": false,
        "textFormat": false,
        "allowNesting": false,
        "variableName": "string",
        "excludeHeaders": false,
        "description": "Action to retrieve a specified range of data from a excel sheet",
        "supervitySchema": {
            "input": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "object",
                "properties": {
                    "path": {
                        "type": "string",
                        "description": "Excel file path"
                    },
                    "range": {
                        "type": "string",
                        "description": "Range of data to be read"
                    },
                    "values": {
                        "type": "boolean",
                        "description": "Whether values to be read or not"
                    },
                    "sheetName": {
                        "type": "string",
                        "description": "Name of the sheet"
                    },
                    "textFormat": {
                        "type": "boolean",
                        "description": "Whether to read in text format or not"
                    },
                    "variableName": {
                        "type": "string",
                        "description": "Name of the variable into whih data to be loaded"
                    },
                    "excludeHeaders": {
                        "type": "boolean",
                        "description": "Whether to exclude columns from data or not"
                    }
                },
                "required": ["path", "sheetName", "variableName"]
            },
            "output": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "array",
                "items": {
                    "type": "array",
                    "items": {
                        "type": "string"
                    }
                }
            }
        }
    },
    {
        "key": "getcellcolor",
        "type": "GET_CELL_COLOR",
        "label": "Get Cell Color",
        "groupType": "excel",
        "status": true,
        "sheetName": "string",
        "breakpoint": false,
        "cellAddress": "string",
        "allowNesting": false,
        "variableName": "string",
        "description": "Retrieve the color of a cell in the specified excel sheet",
        "supervitySchema": {
            "input": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "object",
                "properties": {
                    "path": {
                        "type": "string",
                        "description": "Excel file path"
                    },
                    "sheetName": {
                        "type": "string",
                        "description": "Name of the sheet"
                    },
                    "cellAddress": {
                        "type": "string",
                        "description": "Address of the cell"
                    },
                    "variableName": {
                        "type": "string",
                        "description": "Name of the variable to hold cell color"
                    }
                },
                "required": ["path", "sheetName", "cellAddress", "variableName"]
            },
            "output": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "string",
                "description": "Color code of the specified gcell"
            }
        }
    },
    {
        "key": "setrangecolor",
        "type": "SET_RANGE_COLOR",
        "groupType": "excel",
        "label": "Set Range Color",
        "status": true,
        "color": "string",
        "range": "string",
        "sheetName": "string",
        "breakpoint": false,
        "allowNesting": false,
        "variableName": "string",
        "description": "Action to set color for a specific range on a excel sheet",
        "supervitySchema": {
            "input": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "object",
                "properties": {
                    "path": {
                        "type": "string",
                        "description": "Excel File path"
                    },
                    "color": {
                        "type": "string",
                        "description": "Color to be applied to the range of data"
                    },
                    "range": {
                        "type": "string",
                        "description": "Range of data to be considered"
                    },
                    "sheetName": {
                        "type": "string",
                        "description": "Name of the sheet"
                    }
                },
                "required": ["path", "color", "range", "sheetName"]
            },
            "output": {}
        }
    },
    {
        "key": "getcellformula",
        "type": "GET_CELL_FORMULA",
        "groupType": "excel",
        "label": "Get Cell Formula",
        "status": true,
        "sheetName": "string",
        "breakpoint": false,
        "cellAddress": "string",
        "allowNesting": false,
        "variableName": "string",
        "description": "Retrieve the formula of a specific cell in given excel sheet",
        "supervitySchema": {
            "input": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "object",
                "properties": {
                    "path": {
                        "type": "string",
                        "description": "Excel File path"
                    },
                    "sheetName": {
                        "type": "string",
                        "description": "Name of the sheet"
                    },
                    "cellAddress": {
                        "type": "string",
                        "description": "Address of the cell"
                    },
                    "variableName": {
                        "type": "string",
                        "description": "Name of the variable to hold formula"
                    }
                },
                "required": ["path", "sheetName", "cellAddress", "variableName"]
            },
            "output": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "string",
                "description": "Color code of the specified gcell"
            }
        }
    },
    {
        "key": "convertxlsx",
        "type": "CONVERT_XLSX",
        "label": "Convert to XLSX",
        "groupType": "excel",
        "status": true,
        "fileName": "string",
        "sheetName": "string",
        "breakpoint": false,
        "sourcePath": "string",
        "allowNesting": false,
        "variableName": "string",
        "description": "Action to convert a file to XLSX excel format",
        "supervitySchema": {
            "input": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "object",
                "description": "Schema representing a configuration for a specific task.",
                "properties": {
                    "fileName": {
                        "type": "string",
                        "description": "Name of the file"
                    },
                    "sourcePath": {
                        "type": "string",
                        "description": "Source path"
                    }
                },
                "required": ["fileName", "sourcePath"]
            },
            "output": {}
        }
    },
    {
        "key": "createExcel",
        "type": "CREATE_EXCEL",
        "label": "Create Excel",
        "groupType": "excel",
        "status": true,
        "fileName": "string",
        "breakpoint": false,
        "sourcePath": "string",
        "allowNesting": false,
        "description": "Action to create an Excel file",
        "supervitySchema": {
            "input": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "object",
                "description": "Schema representing a configuration for a specific task.",
                "properties": {
                    "fileName": {
                        "type": "string",
                        "description": "Name of the file to be created"
                    },
                    "sourcePath": {
                        "type": "string",
                        "description": "Source path for the file to be created"
                    }
                },
                "required": ["fileName", "sourcePath"]
            },
            "output": {}
        }
    },
    {
        "key": "getcolumn",
        "type": "GET_COLUMN",
        "groupType": "excel",
        "label": "Get Column",
        "status": true,
        "sheetName": "string",
        "breakpoint": false,
        "storeCache": false,
        "allowNesting": false,
        "variableName": "string",
        "columnAddress": "string",
        "description": "Action to retrieve a specific column from a excel spreadsheet",
        "supervitySchema": {
            "input": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "object",
                "properties": {
                    "path": {
                        "type": "string",
                        "description": "Excel File path"
                    },
                    "sheetName": {
                        "type": "string",
                        "description": "Name of the sheet"
                    },
                    "variableName": {
                        "type": "string",
                        "description": "Name of the variable"
                    },
                    "columnAddress": {
                        "type": "string",
                        "description": "Name of the column"
                    }
                },
                "required": ["path", "sheetName", "variableName", "columnAddress"]
            },
            "output": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "array",
                "description": "An array of arrays representing a tabular data structure.",
                "items": [
                    {
                        "type": "array",
                        "description": "An inner array representing a row of the table.",
                        "items": [
                            {
                                "type": "string",
                                "description": "Column 1: Represents a string value."
                            }
                        ]
                    }
                ]
            }
        }
    },
    {
        "key": "insertcolumn",
        "type": "INSERT_COLUMN",
        "groupType": "excel",
        "label": "Insert Column",
        "status": true,
        "position": "string",
        "noColumns": "string",
        "sheetName": "string",
        "breakpoint": false,
        "allowNesting": false,
        "description": "Action to insert/add a column in a excel sheet",
        "supervitySchema": {
            "input": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "object",
                "properties": {
                    "path": {
                        "type": "string",
                        "description": "Excel File path"
                    },
                    "position": {
                        "type": "string",
                        "description": "Position of the column"
                    },
                    "noColumns": {
                        "type": "string",
                        "description": "Number of columns to be inserted"
                    },
                    "sheetName": {
                        "type": "string",
                        "description": "Name of the sheet"
                    }
                },
                "required": ["path", "position", "noColumns", "sheetName"]
            },
            "output": {}
        }
    },
    {
        "key": "refreshExcel",
        "type": "REFRESH_EXCEL",
        "label": "Refresh Excel File",
        "status": true,
        "groupType": "excel",
        "breakpoint": false,
        "allowNesting": false,
        "description": "Action to refresh an Excel file",
        "supervitySchema": {
            "input": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "object",
                "properties": {
                    "path": {
                        "type": "string",
                        "description": "Excel File path"
                    }
                },
                "required": ["path"]
            },
            "output": {}
        }
    },
    {
        "key": "sortexcelcolumn",
        "type": "SORT_EXCEL_COLUMN",
        "label": "Sort Excel Column",
        "status": true,
        "groupType": "excel",
        "sortType": "string",
        "sheetName": "string",
        "breakpoint": false,
        "allowNesting": false,
        "variableName": "string",
        "columnAddress": "string",
        "description": "Action to sort a column in an Excel sheet",
        "supervitySchema": {
            "input": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "object",
                "properties": {
                    "path": {
                        "type": "string",
                        "description": "Excel File path"
                    },
                    "sortType": {
                        "type": "string",
                        "enum": ["ascending", "descending"],
                        "description": "Type of sorting to be applied"
                    },
                    "sheetName": {
                        "type": "string",
                        "description": "Name of the sheet"
                    },
                    "variableName": {
                        "type": "string",
                        "description": "Name of the variable to hold data"
                    },
                    "columnAddress": {
                        "type": "string",
                        "description": "Address of the column"
                    }
                },
                "required": [
                    "path",
                    "sortType",
                    "sheetName",
                    "variableName",
                    "columnAddress"
                ]
            },
            "output": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "array",
                "items": [
                    {
                        "type": "string",
                        "description": "First string value."
                    }
                ]
            }
        }
    },
    {
        "key": "vlookup",
        "type": "VLOOK_UP",
        "label": "Vlook Up",
        "status": true,
        "sheetName": "string",
        "groupType": "excel",
        "breakpoint": false,
        "columnIndex": "string",
        "allowNesting": false,
        "variableName": "string",
        "columnAddress": "string",
        "description": "Performs a VLOOKUP operation in Excel",
        "supervitySchema": {
            "input": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "object",
                "description": "Schema representing properties of an object.",
                "properties": {
                    "path": {
                        "type": "string",
                        "description": "Excel Path"
                    },
                    "sheetName": {
                        "type": "string",
                        "description": "Name of the sheet"
                    },
                    "columnIndex": {
                        "type": "string",
                        "description": "Index of the column"
                    },
                    "variableName": {
                        "type": "string",
                        "description": "Name of the variable to hold data"
                    },
                    "columnAddress": {
                        "type": "string",
                        "description": "Address of the column"
                    }
                },
                "required": [
                    "path",
                    "sheetName",
                    "columnIndex",
                    "variableName",
                    "columnAddress"
                ]
            },
            "output": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "array",
                "items": {
                    "type": "array",
                    "items": {
                        "type": "string"
                    }
                }
            }
        }
    },
    {
        "key": "dateformat",
        "type": "DATE_FORMAT",
        "label": "Date Format",
        "status": true,
        "variable": "string",
        "dateFormat": "string",
        "selectedDay": 0,
        "allowNesting": false,
        "description": "Action to customize the date format",
        "supervitySchema": {
            "input": {
                "$schema": "http://json-schema.org/draft-04/schema#",
                "type": "object",
                "properties": {
                    "variable": {
                        "type": "string",
                        "description": "A variable to store the date"
                    },
                    "dateFormat": {
                        "type": "string",
                        "description": "The format of the date."
                    },
                    "selectedDay": {
                        "type": "integer",
                        "description": "Select a day"
                    }
                },
                "required": ["variable", "dateFormat", "selectedDay"]
            },
            "output": {}
        }
    },
    {
        "key": "XmlToJson",
        "name": "XML to JSON",
        "type": "XML_TO_JSON",
        "label": "XML To JSON",
        "status": true,
        "xmlText": "string",
        "selector": "",
        "actionType": "XML_TO_JSON",
        "breakpoint": false,
        "selectType": "string",
        "xmlVarName": "string",
        "configuring": false,
        "imgSelector": "string",
        "instruction": "string",
        "xmlFilePath": "string",
        "allowNesting": false,
        "jsonVariable": "string",
        "selectorType": "string",
        "description": "Converts the given XML data into JSON structure",
        "supervitySchema": {
            "input": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "object",
                "properties": {
                    "selectType": {
                        "type": "string",
                        "enum": ["xmlfilePath", "xmlText", "xmlVarName"],
                        "description": "Describes the type of selector used for selecting elements within XML."
                    },
                    "jsonVariable": {
                        "type": "string",
                        "description": "The variable name under which the resulting JSON content is stored."
                    }
                },
                "required": ["selectType", "jsonVariable"],
                "if": {
                    "properties": {
                        "selectType": {
                            "const": "xmlfilePath"
                        }
                    }
                },
                "then": {
                    "properties": {
                        "xmlFilePath": {
                            "type": "string",
                            "description": "The file path to the XML file if the XML is not directly provided as text."
                        }
                    },
                    "required": ["xmlFilePath"]
                },
                "else": {
                    "properties": {
                        "selectType": {
                            "const": "xmlText"
                        }
                    },
                    "then": {
                        "properties": {
                            "xmlText": {
                                "type": "string",
                                "description": "The XML content in string format."
                            }
                        },
                        "required": ["xmlText"],
                        "if": {
                            "properties": {
                                "selectType": {
                                    "const": "xmlVarName"
                                }
                            }
                        },
                        "then": {
                            "properties": {
                                "xmlVarName": {
                                    "type": "string",
                                    "description": "The variable name under which the XML content is stored."
                                }
                            },
                            "required": ["xmlVarName"]
                        }
                    }
                }
            },
            "output": {}
        }
    },
    {
        "key": "throw",
        "name": "Throw Error",
        "type": "THROW",
        "label": "Throw",
        "status": true,
        "errorMsg": "string",
        "actionType": "THROW",
        "breakpoint": false,
        "configuring": true,
        "instruction": "string",
        "allowNesting": true,
        "description": "Throws the given error message",
        "supervitySchema": {
            "input": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "object",
                "properties": {
                    "errorMsg": {
                        "type": "string",
                        "description": "The error message that will be thrown by this action."
                    }
                },
                "required": ["errorMsg"]
            },
            "output": {}
        }
    },
    {
        "key": "string",
        "type": "STRING_FORMAT",
        "label": "String",
        "status": true,
        "match": "string",
        "custom": "string",
        "split1": "string",
        "split2": "string",
        "substr1": "string",
        "substr2": "string",
        "replace1": "string",
        "replace2": "string",
        "variable1": "string",
        "variable2": "string",
        "stringMethod": "string",
        "allowNesting": false,
        "description": "Action to format a string",
        "supervitySchema": {
            "input": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "object",
                "properties": {
                    "match": {
                        "type": "string",
                        "description": "A string used for matching purposes."
                    },
                    "custom": {
                        "type": "string",
                        "description": "A custom string associated with the object."
                    },
                    "split1": {
                        "type": "string",
                        "description": "The first part obtained after splitting a string."
                    },
                    "split2": {
                        "type": "string",
                        "description": "The second part obtained after splitting a string."
                    },
                    "status": {
                        "type": "boolean",
                        "description": "The status of the object (true or false)."
                    },
                    "substr1": {
                        "type": "string",
                        "description": "A substring associated with the object."
                    },
                    "substr2": {
                        "type": "string",
                        "description": "Another substring associated with the object."
                    },
                    "parentId": {
                        "type": "string",
                        "description": "The identifier of the parent object."
                    },
                    "replace1": {
                        "type": "string",
                        "description": "The first string used for replacement."
                    },
                    "replace2": {
                        "type": "string",
                        "description": "The second string used for replacement."
                    },
                    "variable1": {
                        "type": "string",
                        "description": "A variable associated with the object."
                    },
                    "variable2": {
                        "type": "string",
                        "description": "Another variable associated with the object."
                    },
                    "stringMethod": {
                        "type": "string",
                        "description": "A method used for string manipulation."
                    }
                },
                "required": [
                    "match",
                    "custom",
                    "split1",
                    "split2",
                    "status",
                    "substr1",
                    "substr2",
                    "replace1",
                    "replace2",
                    "variable1",
                    "variable2",
                    "stringMethod"
                ]
            },
            "output": {
                "$schema": "http://json-schema.org/draft-04/schema#",
                "type": "array",
                "items": [
                    {
                        "type": "string"
                    }
                ]
            }
        }
    },
    {
        "key": "s3downloadfile",
        "type": "S3_FILE_DOWNLOAD",
        "label": "Download File",
        "status": true,
        "Region": "string",
        "Archive": false,
        "keyName": "string",
        "actionType": "S3_FILE_DOWNLOAD",
        "breakpoint": false,
        "bucketName": "string",
        "folderPath": "string",
        "configuring": true,
        "ArchiveKeyName": "string",
        "allowNesting": false,
        "description": "Action to download a file from S3",
        "supervitySchema": {
            "input": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "object",
                "properties": {
                    "Region": {
                        "type": "string",
                        "description": "The AWS region where the S3 bucket is located."
                    },
                    "Archive": {
                        "type": "boolean",
                        "description": "A boolean flag indicating whether the file should be archived after downloading."
                    },
                    "keyName": {
                        "type": "string",
                        "description": "The key name of the file within the S3 bucket to download."
                    },
                    "bucketName": {
                        "type": "string",
                        "description": "The name of the S3 bucket from which the file is to be downloaded."
                    },
                    "folderPath": {
                        "type": "string",
                        "description": "The path within the bucket where the file is located."
                    },
                    "ArchiveKeyName": {
                        "type": "string",
                        "description": "The key name under which the file will be archived, if archiving is enabled."
                    }
                },
                "required": [
                    "Region",
                    "Archive",
                    "keyName",
                    "bucketName",
                    "folderPath",
                    "ArchiveKeyName"
                ]
            },
            "output": {}
        }
    },
    {
        "key": "connection",
        "type": "DB_CONNECTION",
        "label": "Connection",
        "status": true,
        "host": "string",
        "port": "string",
        "query": "string",
        "isFIPS": "string",
        "db_type": "string",
        "db_token": "string",
        "password": "string",
        "username": "string",
        "variable": "string",
        "actionType": "DB_CONNECTION",
        "breakpoint": false,
        "subActions": [],
        "configuring": false,
        "servicename": "string",
        "withColumns": false,
        "allowNesting": true,
        "databasename": "string",
        "selectorType": "string",
        "showPassword": false,
        "description": "Establishes a connection to a database.",
        "supervitySchema": {
            "input": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "object",
                "properties": {
                    "sid": {
                        "type": "string",
                        "description": "The SID (System IDentifier) of the database."
                    },
                    "host": {
                        "type": "string",
                        "description": "The hostname or IP address of the database server."
                    },
                    "name": {
                        "type": "string",
                        "description": "The name of the database connection."
                    },
                    "port": {
                        "type": "string",
                        "description": "The port number on which the database server is listening."
                    },
                    "isFIPS": {
                        "type": "string",
                        "description": "Flag indicating whether FIPS (Federal Information Processing Standards) mode is enabled."
                    },
                    "db_type": {
                        "type": "string",
                        "enum": ["oracle", "mysql", "postgre", "mssql"],
                        "description": "The type of the database (e.g., MySQL, PostgreSQL)."
                    },
                    "password": {
                        "type": "string",
                        "description": "The password for accessing the database."
                    },
                    "username": {
                        "type": "string",
                        "description": "The username for accessing the database."
                    },
                    "variable": {
                        "type": "string",
                        "description": "A variable associated with the database connection."
                    },
                    "actionType": {
                        "type": "string",
                        "description": "The type of action to perform on the database."
                    },
                    "servicename": {
                        "type": "string",
                        "description": "The service name of the database."
                    },
                    "withColumns": {
                        "type": "boolean",
                        "description": "Flag indicating whether to include column information."
                    },
                    "databasename": {
                        "type": "string",
                        "description": "The name of the database."
                    }
                },
                "required": [
                    "sid",
                    "host",
                    "name",
                    "port",
                    "db_type",
                    "password",
                    "username",
                    "variable",
                    "actionType",
                    "servicename",
                    "databasename"
                ]
            },
            "output": {}
        }
    },
    {
        "key": "executequery",
        "type": "DB_EXECUTE_QUERY",
        "label": "Execute Query",
        "status": true,
        "sid": "string",
        "dbId": "string",
        "host": "string",
        "name": "string",
        "port": "string",
        "query": "string",
        "isFIPS": false,
        "db_type": "string",
        "db_token": "string",
        "password": "string",
        "username": "string",
        "variable": "string",
        "actionType": "string",
        "breakpoint": false,
        "subActions": [],
        "servicename": "string",
        "withColumns": false,
        "databasename": "string",
        "selectorType": "string",
        "showPassword": false,
        "description": "Executes a specified database query.",
        "supervitySchema": {
            "input": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "object",
                "properties": {
                    "name": {
                        "type": "string",
                        "description": "The name of the database connection."
                    },
                    "query": {
                        "type": "string",
                        "description": "The query to be executed on the database."
                    },
                    "variable": {
                        "type": "string",
                        "description": "A variable associated with the database connection."
                    },
                    "servicename": {
                        "type": "string",
                        "description": "The service name of the database."
                    },
                    "withColumns": {
                        "type": "boolean",
                        "description": "Flag indicating whether to include column information."
                    },
                    "databasename": {
                        "type": "string",
                        "description": "The name of the database."
                    }
                },
                "required": ["name", "query", "variable", "withColumns", "databasename"]
            },
            "output": {
                "$schema": "http://json-schema.org/draft-04/schema#",
                "type": "array",
                "items": {
                    "type": "array",
                    "items": {
                        "type": "string",
                        "description": "An array of strings representing items."
                    }
                }
            }
        }
    },
    {
        "key": "copyfilefolder",
        "groupType": "filesandfolders",
        "type": "COPYFILESFOLDERS_ACTION",
        "label": "Copy File/Folder",
        "status": true,
        "mode": "string",
        "skip": "string",
        "subType2": "string",
        "breakpoint": false,
        "sourcePath": "string",
        "destinationPath": "string",
        "variableName": "string",
        "description": "Action to copy a file or folder from source path to destination path.",
        "supervitySchema": {
            "input": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "object",
                "properties": {
                    "mode": {
                        "type": "string",
                        "enum": ["copy", "move"],
                        "description": "Mode of operation for the object."
                    },
                    "skip": {
                        "type": "string",
                        "enum": ["skip", "overwrite"],
                        "description": "A value indicating whether to skip this object."
                    },
                    "subType2": {
                        "type": "string",
                        "enum": ["file", "folder"],
                        "description": "A subtype of the object."
                    },
                    "sourcePath": {
                        "type": "string",
                        "description": "Path of the source file/folder for the object."
                    },
                    "destinationPath": {
                        "type": "string",
                        "description": "Path of the destination file/folder for the object."
                    }
                },
                "required": [
                    "mode",
                    "skip",
                    "subType2",
                    "sourcePath",
                    "destinationPath"
                ]
            },
            "output": {}
        }
    },
    {
        "key": "deletefilefolder",
        "groupType": "filesandfolders",
        "type": "DELETEFILESFOLDERS_ACTION",
        "label": "Delete File/Folder",
        "status": true,
        "subType2": "string",
        "breakpoint": false,
        "description": "Action to delete a file or folder",
        "supervitySchema": {
            "input": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "object",
                "properties": {
                    "path": {
                        "type": "string",
                        "description": "File/folder Path which needs to be deleted"
                    },
                    "subType2": {
                        "type": "string",
                        "enum": ["file", "folder"],
                        "description": "A subtype of the object."
                    }
                },
                "required": ["path", "subType2"]
            },
            "output": {}
        }
    },
    {
        "key": "readfile",
        "groupType": "filesandfolders",
        "type": "READFILE",
        "label": "Read File",
        "status": true,
        "dates": "string",
        "filePath": "string",
        "variable": "string",
        "actionType": "READFILE",
        "breakpoint": false,
        "configuring": false,
        "ifCondition": "string",
        "extractToSameLocation": false,
        "allowNesting": false,
        "description": "Reads a file from specified file path and stores the content in a variable.",
        "supervitySchema": {
            "input": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "object",
                "properties": {
                    "path": {
                        "type": "string",
                        "description": "Path related to the object."
                    },
                    "filePath": {
                        "type": "string",
                        "description": "File path associated with the object."
                    },
                    "variable": {
                        "type": "string",
                        "description": "Variable associated with the object."
                    }
                },
                "required": ["path", "filePath", "variable"]
            },
            "output": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "string"
            }
        }
    },
    {
        "key": "unzipfiles",
        "groupType": "filesandfolders",
        "type": "UNZIPFILES",
        "label": "Unzip Files",
        "status": true,
        "skip": "string",
        "breakpoint": false,
        "sourcePath": "string",
        "variableName": "string",
        "destinationPath": "string",
        "extractToSameLocation": false,
        "allowNesting": false,
        "description": "Action to unzip files",
        "supervitySchema": {
            "input": {
                "$schema": "http://json-schema.org/draft-04/schema#",
                "type": "object",
                "properties": {
                    "skip": {
                        "type": "string",
                        "enum": ["skip", "overwrite"],
                        "description": "Specifies if the files in the destination folder to be overwrittten or not."
                    },
                    "sourcePath": {
                        "type": "string",
                        "description": "Path of the source file or location."
                    },
                    "extractToSameLocation": {
                        "type": "boolean",
                        "description": "Specifies whether to extract to the same location or not."
                    }
                },
                "required": ["skip", "sourcePath", "extractToSameLocation"],
                "if": {
                    "properties": {
                        "extractToSameLocation": {
                            "const": false
                        }
                    }
                },
                "then": {
                    "properties": {
                        "destinationPath": {
                            "type": "string",
                            "description": "The path where files should be extracted if not extracting to the same location."
                        }
                    },
                    "required": ["destinationPath"]
                }
            },
            "output": {}
        }
    },
    {
        "key": "writetofile",
        "groupType": "filesandfolders",
        "type": "WRITEFILE",
        "label": "Write to File",
        "status": true,
        "skip": "string",
        "dates": "string",
        "content": "string",
        "filePath": "string",
        "actionType": "string",
        "breakpoint": false,
        "configuring": false,
        "ifCondition": "string",
        "variableName": "string",
        "extractToSameLocation": false,
        "description": "Action to write content to a file.",
        "supervitySchema": {
            "input": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "object",
                "properties": {
                    "path": {
                        "type": "string",
                        "description": "File Path related to the object."
                    },
                    "skip": {
                        "type": "string",
                        "enum": ["overwrite", "append"],
                        "description": "A value indicating whether to skip this object."
                    },
                    "content": {
                        "type": "string",
                        "description": "Content which needs to write to the file object."
                    },
                    "filePath": {
                        "type": "string",
                        "description": "File path associated with the object."
                    }
                },
                "required": ["path", "skip", "content", "filePath"]
            },
            "output": {}
        }
    },
    {
        "key": "createfilefolder",
        "path": "string",
        "skip": "string",
        "type": "CREATEFILESFOLDERS_ACTION",
        "label": "Create File/Folder",
        "status": true,
        "actionType": "string",
        "breakpoint": false,
        "configuring": false,
        "ifCondition": "string",
        "variableName": "string",
        "subType2": "string",
        "description": "Action to create a file or folder.",
        "supervitySchema": {
            "input": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "object",
                "properties": {
                    "path": {
                        "type": "string",
                        "description": "File or folder Path related to the object."
                    },
                    "subType2": {
                        "type": "string",
                        "enum": ["file", "folder"],
                        "description": "Content which needs to write to the file object."
                    }
                },
                "required": ["path", "subType2"],
                "if": {
                    "properties": {
                        "subType2": {
                            "const": "folder"
                        }
                    }
                },
                "then": {
                    "properties": {
                        "skip": {
                            "type": "string",
                            "enum": ["skip", "overwrite"],
                            "description": "A skip value indicating whether to skip or overwrite the folder while creating"
                        }
                    },
                    "required": ["skip"]
                }
            },
            "output": {}
        }
    },
    {
        "key": "getfoldercontents",
        "groupType": "filesandfolders",
        "type": "GETFOLDERCONSTANTS",
        "label": "Get Folder Contents",
        "status": true,
        "dates": "string",
        "filter": "string",
        "ifDate": "string",
        "toDate": "string",
        "fromDate": "string",
        "variable": "string",
        "toDateVar": "string",
        "breakpoint": false,
        "fromDateVar": "string",
        "ifCondition": "string",
        "variableName": "string",
        "ifDateModified": true,
        "description": "Retrieve the contents of a folder as specified by the input parameters.",
        "supervitySchema": {
            "input": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "object",
                "properties": {
                    "path": {
                        "type": "string",
                        "description": "The folder path from where content to be read"
                    },
                    "variable": {
                        "type": "string",
                        "description": "The variable associated with the object."
                    },
                    "ifDateModified": {
                        "type": "boolean",
                        "description": "The condition associated with the object."
                    },
                    "ifCondition": {
                        "type": "string",
                        "enum": ["files", "folders"],
                        "description": "The condition associated with the object."
                    }
                },
                "required": ["path", "variable", "ifCondition"],
                "allOf": [
                    {
                        "if": {
                            "properties": {
                                "ifCondition": {
                                    "const": "files"
                                }
                            }
                        },
                        "then": {
                            "properties": {
                                "filter": {
                                    "type": "string",
                                    "description": "Filter criteria to filter the files in the source path"
                                }
                            },
                            "required": ["filter"]
                        }
                    },
                    {
                        "if": {
                            "properties": {
                                "ifDateModified": {
                                    "const": true
                                }
                            }
                        },
                        "then": {
                            "properties": {
                                "dates": {
                                    "type": "string",
                                    "enum": ["static", "dynamic"],
                                    "description": "Whether files to be extracted by last modified date"
                                }
                            },
                            "required": ["dates"],
                            "if": {
                                "properties": {
                                    "dates": {
                                        "const": "static"
                                    }
                                }
                            },
                            "then": {
                                "properties": {
                                    "fromDate": {
                                        "type": "string",
                                        "description": "From date to filter files/folders"
                                    },
                                    "toDate": {
                                        "type": "string",
                                        "description": "To date to filter files/folders"
                                    }
                                },
                                "required": ["fromDate", "toDate"],
                                "else": {
                                    "properties": {
                                        "dates": {
                                            "const": "dynamic"
                                        }
                                    }
                                },
                                "then": {
                                    "properties": {
                                        "fromDateVar": {
                                            "type": "string",
                                            "description": "From date to filter files/folders"
                                        },
                                        "toDateVar": {
                                            "type": "string",
                                            "description": "To date to filter files/folders"
                                        }
                                    },
                                    "required": ["fromDateVar", "toDateVar"]
                                }
                            }
                        }
                    }
                ]
            },
            "output": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "array",
                "items": {
                    "type": "array",
                    "items": {
                        "type": "string",
                        "description": "An array of strings representing items."
                    }
                }
            }
        }
    },
    {
        "key": "writecell",
        "type": "WRITE_CELL",
        "groupType": "excel",
        "label": "Write Cell",
        "status": true,
        "cellValue": "string",
        "sheetName": "string",
        "breakpoint": false,
        "cellAddress": "string",
        "allowNesting": false,
        "variableName": "string",
        "description": "Action to write a value to a specific cell in a excel spreadsheet",
        "supervitySchema": {
            "input": {
                "$schema": "http://json-schema.org/draft-07/schema#",
                "type": "object",
                "properties": {
                    "cellValue": {
                        "type": "string",
                        "description": "Value to be written into cell"
                    },
                    "sheetName": {
                        "type": "string",
                        "description": "Name of the sheet where the target cell is present."
                    },
                    "cellAddress": {
                        "type": "string",
                        "description": "Target cell address where the value has to be written."
                    },
                },
                "required": ["sheetName", "cellValue", "cellAddress"]
            },
            "output": {}
        }
      },
]
